import React, { Component } from 'react';
import { FORMAT_NUMBER, SERVICE_API, CURRENCY, BASE_URL } from '../libs/utils/Const';
import '../css/dashboard.css';
import '../css/detailItemSale.css'
import '../css/responsive.css'



class DetailsItemSale extends Component {
    shouldComponentUpdate = (nextProps, nextState, nextContext) => {
        if (this.props.item !== nextProps.item) {
            return true;
        } else {
            return false;
        }
    }

    render() {
        const { item } = this.props;
        return (
            <div className="col-3 imgColum" style={{ top: "80px", position: "fixed", left: "0rem" }}>
                <div className="ml-3" style={{ marginTop: "0.5rem" }}>
                    <div className="text-center product pl-4 pt-5 border-0 h-100 ">
                        <img
                            className="img-fluid d-block mx-auto "
                            src={item.PicturName ? (BASE_URL + SERVICE_API.getImage + '/' + item.PicturName) : require('../images/logoGlobalInfo.png')} 
                            alt= 'Imagen de artículo'/>
                        <div className="p-4 py-0 h-xs-440p scrollDetail ">
                            <h5 className="font-weight-semi-bold mb-3 w-xl-220p mx-auto">{item.ItemName || ''}</h5>
                            <div className="">
                            <p className="price">{`${CURRENCY} ${FORMAT_NUMBER.new(item.Price)}`}</p>
                            <p className="price ">{item.UserText || ''}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default DetailsItemSale;


